import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AnalysisMode } from '../../models/uploadFile';
import { Option } from '../../components/select/select.component';

interface ReanalyzeConfirmationDialogData {
  titleKey: string;
  text: string;
  analysis: AnalysisMode;
}

export type ReanalyzeConfirmationDialogResult = {
  confirmed: boolean;
  analysis: AnalysisMode;
}

@Component({
  selector: 'app-reanalyze-confirmation-dialog',
  templateUrl: './reanalyze-confirmation-dialog.component.html',
  styleUrls: ['./reanalyze-confirmation-dialog.component.scss']
})
export class ReanalyzeConfirmationDialogComponent {
  public readonly analysisModes: Array<Option> = [
    {
      value: AnalysisMode.LIGHT,
      label: 'UPLOAD_DOCUMENT.ANALYSIS_MODE_LIGHT'
    },
    {
      value: AnalysisMode.FULL,
      label: 'UPLOAD_DOCUMENT.ANALYSIS_MODE_FULL'
    }
  ];

  public analysis: AnalysisMode;

  get isDisabled() {
    return !this.analysis;
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly data: ReanalyzeConfirmationDialogData,
    private readonly dialogRef: MatDialogRef<ReanalyzeConfirmationDialogComponent>
  ) {
    this.analysis = this.data.analysis ?? AnalysisMode.LIGHT;
  }

  public onConfirm() {
    this.dialogRef.close({
      confirmed: true,
      analysis: this.analysis
    } as ReanalyzeConfirmationDialogResult)
  }

  public onCancel() {
    this.dialogRef.close();
  }
}
